import { render } from "./JCheckBox.vue?vue&type=template&id=87b718c8"
import script from "./JCheckBox.vue?vue&type=script&lang=js"
export * from "./JCheckBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__